"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAnalytics = exports.callAnalyticsInit = void 0;
var effects_1 = require("redux-saga/effects");
var analytics_1 = __importDefault(require("../analytics"));
var google_analytics_1 = __importDefault(require("../providers/google-analytics"));
var logger_analytics_1 = __importDefault(require("../providers/logger-analytics"));
var application_insights_1 = __importDefault(require("../providers/application-insights"));
var google_tag_manager_1 = __importDefault(require("../providers/google-tag-manager"));
var analytics_action_types_1 = require("../actions/analytics-action-types");
function reportPageView(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, effects_1.call)(function () { return analytics_1.default.pageView(payload); })];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
var callAnalyticsInit = function (payload) {
    var providers = [
        new google_analytics_1.default(payload.googleAnalyticsTrackingIds, payload === null || payload === void 0 ? void 0 : payload.googleAnalyticsPrefix),
        new application_insights_1.default(payload.appInsightsId, payload === null || payload === void 0 ? void 0 : payload.appInsightsEnableCorsCorrelation, payload === null || payload === void 0 ? void 0 : payload.appInsightsCorrelationHeaderExcludeDomains, payload === null || payload === void 0 ? void 0 : payload.appInsightsTracingMode),
        new logger_analytics_1.default(payload.enabledConsoleLog),
        new google_tag_manager_1.default(payload === null || payload === void 0 ? void 0 : payload.gtmId),
    ];
    analytics_1.default.init(providers);
};
exports.callAnalyticsInit = callAnalyticsInit;
function initializeAnalytics(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.call)(exports.callAnalyticsInit, action.payload)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.initializeAnalytics = initializeAnalytics;
function main() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(analytics_action_types_1.REPORT_PAGE_EVENT, reportPageView)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(analytics_action_types_1.INIT_ANALYTICS, initializeAnalytics)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = main;
